var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconTp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7539 22.5999C17.829 22.5999 22.7539 17.675 22.7539 11.5999C22.7539 5.52472 17.829 0.599854 11.7539 0.599854C5.67877 0.599854 0.753906 5.52472 0.753906 11.5999C0.753906 17.675 5.67877 22.5999 11.7539 22.5999Z",
    stroke: "#333333",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7551 15.0568C14.323 15.0568 16.4047 12.9751 16.4047 10.4072C16.4047 7.83926 14.323 5.75757 11.7551 5.75757C9.18716 5.75757 7.10547 7.83926 7.10547 10.4072C7.10547 12.9751 9.18716 15.0568 11.7551 15.0568Z",
    stroke: "#333333",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59766 19.9494C5.77938 17.1662 8.52938 15.2114 11.7543 15.2114C14.9792 15.2114 17.7292 17.1662 18.9109 19.9494",
    stroke: "#333333",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconTp);
export default __webpack_public_path__ + "static/media/user-icon-tp.8ebd11ecaee3f2c31139f8cfe7dacd65.svg";
export { ForwardRef as ReactComponent };